<template>
  <div class="cart-voucher new-cart-voucher">
    <div
      v-for="(promotion, index) in appliedOrderPromotions"
      :key="index"
      class="cart-voucher-list">
      <mark>Promotion</mark>
      <div class="vocher-totle">{{ promotion.promotion.name }}</div>
      <div class="voucher-description">{{ promotion.description }}</div>
    </div>
    <div
      v-for="(promotion, index) in appliedProductPromotions"
      :key="index"
      class="cart-voucher-list">
      <mark>Promotion</mark>
      <div class="vocher-totle">{{ promotion.promotion.name }}</div>
      <div class="voucher-description">{{ promotion.description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppliedPromotions",
  props: {
    appliedOrderPromotions: {
      type: Array,
      required: true,
    },
    appliedProductPromotions: {
      type: Array,
      required: true,
    }
  }
}
</script>

<style scoped>

</style>
